module.exports = __webpack_public_path__ + "../static/img/_suite_logo.0dc16b70.png";